import React from "react";
import {
  MdOutlineDateRange,
  MdOutlineTag,
  MdAssignmentInd,
  MdOutlinePriorityHigh,
  MdOutlineEdit,
  MdOutlineDelete,
  MdOutlinePushPin,
} from "react-icons/md";
import { FaLayerGroup, FaUsers } from "react-icons/fa";

const TaskDetails = () => {
  const task = {
    mainTaskTitle: "Task Title",
    mainTaskProgress: 62,
    assignedUsers: [
      { id: 1, avatar: "https://randomuser.me/api/portraits/women/1.jpg" },
      { id: 2, avatar: "https://randomuser.me/api/portraits/men/1.jpg" },
      { id: 3, avatar: "https://randomuser.me/api/portraits/women/2.jpg" },
    ],
    extraUsersCount: 5,
    subTaskTitle: "Task Title",
    subTaskType: "Projects",
    subTaskTeamType: "Team projects",
    card: {
      companyLogo: "HRMS", // Could be an image URL or text
      title: "Wireframe Design",
      description: "Lorem ipsum dolor sit amet",
      createdAt: "Mar 23, 10:34 PM",
      deadline: "Jun 02, 04:01 PM",
      trackedTime: "10h 32m",
    },
    createdAtDetails: "April, 16 2024 13:14 PM",
    tags: ["Profitable", "AI", "1Person"],
    assignee: "Adeola",
    priority: "Small", // Could be 'Small', 'Medium', 'Large' etc.
    description:
      "Lorem ipsum dolor sit amet consectetur. Platea tortor nibh diam mi. Eu libero pharetra commodo malesuada. Id convallis sit nisi auctor cras at tincidunt vel diam. In vehicula turpis lacus fusce tortor sodales ac dignissim sapien. Potenti feugiat varius nunc morbi hendrerit magna. Neque sagittis augue nulla augue magna mattis.",
  };

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8 bg-gray-50 min-h-screen font-sans">
      {/* Header */}
      <h1 className="text-xl font-bold text-gray-900 mb-6">Tasj Details</h1>

      {/* Main Task Progress Section */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-10 h-10 bg-blue-600 text-white font-semibold rounded-full text-xs flex-shrink-0">
              HRMS
            </div>
            <h2 className="text-lg font-bold text-gray-900">
              {task.mainTaskTitle}
            </h2>
          </div>

          <div className="flex-1 min-w-[200px] max-w-lg">
            <div className="h-2 bg-gray-200 rounded-full">
              <div
                className="h-full bg-green-500 rounded-full"
                style={{ width: `${task.mainTaskProgress}%` }}
              ></div>
            </div>
            <p className="text-right text-sm text-gray-600 mt-1">
              {task.mainTaskProgress}% Complete
            </p>
          </div>

          <div className="flex items-center -space-x-2 mr-4">
            {task.assignedUsers.map((user) => (
              <img
                key={user.id}
                className="w-8 h-8 rounded-full border-2 border-white object-cover"
                src={user.avatar}
                alt={`User ${user.id}`}
              />
            ))}
            {task.extraUsersCount > 0 && (
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-700 flex items-center justify-center border-2 border-white text-xs font-semibold">
                +{task.extraUsersCount}
              </div>
            )}
            <button className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center border-2 border-white text-xl ml-2">
              +
            </button>
          </div>
        </div>
      </div>

      {/* Sub Task Section */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-6">
        <div className="flex items-start gap-4 mb-4">
          <div className="flex flex-col items-center mt-1">
            <MdOutlinePushPin className="text-gray-400 text-xl" />
            <div className="h-6 w-px bg-gray-300 my-1"></div>{" "}
            {/* Vertical line */}
          </div>
          <div className="flex-grow">
            <h2 className="text-lg font-bold text-gray-900">
              {task.subTaskTitle}
            </h2>
            <div className="flex items-center space-x-4 text-sm text-gray-600 mt-1">
              <span className="flex items-center gap-1">
                <FaLayerGroup className="text-blue-500" /> {task.subTaskType}
              </span>
              <span className="flex items-center gap-1">
                <FaUsers className="text-red-500" /> {task.subTaskTeamType}
              </span>
            </div>
          </div>
          <div className="flex items-center space-x-2 text-gray-500 text-lg">
            <MdOutlineEdit className="cursor-pointer hover:text-blue-600" />
            <MdOutlineDelete className="cursor-pointer hover:text-red-600" />
          </div>
        </div>

        {/* Wireframe Design Card */}
        <div className="bg-gradient-to-r from-purple-800 to-purple-600 text-white p-6 rounded-xl relative overflow-hidden">
          {/* Background elements (optional, for visual flair like in the image) */}
          <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-purple-500 opacity-20 rounded-full"></div>
          <div className="absolute -top-10 -left-10 w-32 h-32 bg-purple-400 opacity-15 rounded-full"></div>

          <div className="flex items-start gap-4 mb-4 relative z-10">
            <div className="flex items-center justify-center w-12 h-12 bg-white text-purple-800 font-bold rounded-full text-sm flex-shrink-0">
              {task.card.companyLogo}
            </div>
            <div>
              <h3 className="text-xl font-bold">{task.card.title}</h3>
              <p className="text-sm opacity-90">{task.card.description}</p>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-2 text-xs opacity-80 relative z-10">
            <div>
              <p className="font-semibold">Created</p>
              <p>{task.card.createdAt}</p>
            </div>
            <div>
              <p className="font-semibold">Deadline</p>
              <p>{task.card.deadline}</p>
            </div>
            <div>
              <p className="font-semibold">Tracked Time</p>
              <p>{task.card.trackedTime}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Details Section */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column: Icons and Details */}
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <MdOutlineDateRange className="text-blue-500 text-2xl" />
            <div>
              <p className="text-sm font-semibold text-gray-700">Created At</p>
              <p className="text-gray-600">{task.createdAtDetails}</p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <MdOutlineTag className="text-green-500 text-2xl mt-1" />
            <div>
              <p className="text-sm font-semibold text-gray-700">Tags</p>
              <div className="flex flex-wrap gap-2 mt-1">
                {task.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 rounded-full text-xs font-medium"
                    style={{
                      backgroundColor:
                        tag === "Profitable"
                          ? "#dcfce7"
                          : tag === "AI"
                          ? "#e0f2fe"
                          : "#fef2f2",
                      color:
                        tag === "Profitable"
                          ? "#16a34a"
                          : tag === "AI"
                          ? "#0284c7"
                          : "#ef4444",
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <MdAssignmentInd className="text-purple-500 text-2xl" />
            <div>
              <p className="text-sm font-semibold text-gray-700">Assign</p>
              <p className="text-gray-600">{task.assignee}</p>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <MdOutlinePriorityHigh className="text-red-500 text-2xl" />
            <div>
              <p className="text-sm font-semibold text-gray-700">Priority</p>
              <span className="px-3 py-1 bg-gray-200 text-gray-700 text-xs rounded-full font-medium mt-1 inline-block">
                {task.priority}
              </span>
            </div>
          </div>
        </div>

        {/* Right Column: Description */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-sm font-semibold text-gray-700">Description</h3>
            <MdOutlineEdit className="text-gray-500 cursor-pointer hover:text-blue-600" />
          </div>
          <p className="text-gray-600 text-sm leading-relaxed">
            {task.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TaskDetails;
